module.exports = __webpack_public_path__ + "img/lg_ring_g_e_null_1.0b41fbe5.png";